define('cartware/components/Config',[
	"lodash"
], function(
	_
) {
	function Config() {
		this.configObject = {};
	}

	Config.prototype = {
		get: function(key, defaultValue) {
			return _.get(this.configObject, key, defaultValue);
		},

		populate: function(obj) {
			this.configObject = obj;
			return this;
		}
	}

	return (new Config);
});
